import * as React from "react"
import { cn } from "../../lib/utils"

/**
 * Determinate progress bar.
 *
 * `value` is a percentage (0-100). Pass `indeterminate` when work has started
 * but hasn't reported a figure yet — the bar sweeps instead of sitting at zero,
 * which reads as "stalled".
 */
const Progress = React.forwardRef(({ className, value = 0, indeterminate = false, ...props }, ref) => {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));

  return (
    <div
      ref={ref}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={indeterminate ? undefined : Math.round(pct)}
      className={cn("relative h-2 w-full overflow-hidden rounded-full bg-muted", className)}
      {...props}
    >
      <div
        className={cn(
          "h-full rounded-full bg-primary",
          indeterminate ? "w-1/3 progress-indeterminate" : "transition-[width] duration-500 ease-out",
        )}
        style={indeterminate ? undefined : { width: `${pct}%` }}
      />
    </div>
  );
});
Progress.displayName = "Progress";

export { Progress }
